import React, {type MouseEventHandler} from "react";
import {useNavigate} from "react-router-dom";
import {Modal} from "../../modal/Modal";
import "./Item.scss";
import {type Status, isLoading} from "../../../infrastructure/status";

export interface Item {
  id: number;
  name: string;
  date: string;
}

interface ListItemProps {
  item: Item;
  onDelete: (id: number) => void;
  onDownload: (id: number) => void;
  downloadStatus?: Status;
}

export const ListItem: React.FC<ListItemProps> = ({item, downloadStatus, ...props}) => {
  const navigate = useNavigate();

  const onDelete: MouseEventHandler = () => {
    props.onDelete(item.id);
  };

  const onDownload: MouseEventHandler = event => {
    event.stopPropagation();
    props.onDownload(item.id);
  };

  return (
    <tr className="stable-row pointer">
      <td
        onClick={() => {
          navigate(`/edit/${item.id}`);
        }}>
        {item.id}
      </td>
      <td
        onClick={() => {
          navigate(`/edit/${item.id}`);
        }}>
        {item.name}
      </td>
      <td
        onClick={() => {
          navigate(`/edit/${item.id}`);
        }}>
        {item.date}
      </td>
      <td>
        <div className="item-icons">
          <div
            onClick={onDownload}
            className={`icon-wrap item-icon-container ${item.name ? "" : "invisible"}`}
            title="Download">
            <div className="multiple-icons">
              <div className="item-icon">
                {isLoading(downloadStatus) ? (
                  <i className="fad fa-spinner-third fa-spin icon-xs spinner spinner-page dark"></i>
                ) : (
                  <i className="fal fa-download"></i>
                )}
              </div>
            </div>
          </div>
          <Modal
            title={"Delete configuration"}
            body={"Do you want to delete this configuration?"}
            onContinue={onDelete}
            id={`modal-${item.id}`}
            primaryButtonText="Delete">
            <div className="icon-wrap item-icon-container" title="Delete">
              <div className="item-icon">
                <i className="fal fa-trash-alt"></i>
              </div>
            </div>
          </Modal>
        </div>
      </td>
    </tr>
  );
};
